import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Toast,
  Spinner,
  Table,
} from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom"; // Added for routing
import "../../Styles/yellowcalfcss/CreateBill.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";

export default function CreateBill() {
  const navigate = useNavigate();
  const { id } = useParams(); // If your route is /edit-bill/:id
  const location = useLocation();

  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");

  // Mode state
  const [isEditMode, setIsEditMode] = useState(false);
  const [supplierList, setSupplierList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [billId, setBillId] = useState(null);

  // Form states
  const [billNumber, setBillNumber] = useState("");
  const [supplier, setSupplier] = useState("");
  const [billDate, setBillDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [items, setItems] = useState([]);
  console.log("items", items);
  console.log("supplier--", supplier);

  // Current Item Input states
  const [currentItem, setCurrentItem] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState("");
  const [currentUnitPrice, setCurrentUnitPrice] = useState("");
  const [description, setDescription] = useState("");

  // Validation & UI states
  const [errors, setErrors] = useState({});
  const [showItemValidation, setShowItemValidation] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [expenseList, setExpenseList] = useState([]);
  const [billItemsList, setBillItemsList] = useState([]);
  const [stockList, setStockList] = useState([]);

  const [selectedExpense, setSelectedExpense] = useState("");
  const [selectedBillItem, setSelectedBillItem] = useState("");
  const [selectedStock, setSelectedStock] = useState("");
  const [selectedStockObject, setSelectedStockObject] = useState(null);
  const [dropdownsLoaded, setDropdownsLoaded] = useState(false);

  const expenseOptions = expenseList.map((e) => ({
    value: e.expense_type_name,
    label: e.expense_type_name,
  }));

  const billItemOptions = billItemsList.map((b) => ({
    value: b.bill_item_name,
    label: b.bill_item_name,
  }));

  const stockOptions = stockList.map((s) => ({
    value: s.product_name,
    label: `${s.product_name} (${s.stock_count})`,
    original: s, // ✅ keep full object
  }));

  const fetchItemsDropdown2 = async () => {
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billItemsList, // <-- new API key
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        setExpenseList(response?.Expenslist || []);
        setBillItemsList(response?.getbillItems || []);
        setStockList(response?.stocklist || []);
      }
    } catch (error) {
      console.error("Error loading item dropdowns:", error);
    } finally {
      setDropdownsLoaded(true);
    }
  };

  const fetchSupplierList = async (updatedFilters = []) => {
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",

      // ✅ REAL API FILTERS
      name_search: updatedFilters.name_search || "",
      email_search: updatedFilters.email_search || "",
      address_search: updatedFilters.address_search || "",
      number_search: updatedFilters.number_search || "",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.supplierList,
        JSON.stringify(requestBody),
      );

      if (response?.result && Array.isArray(response?.data)) {
        setSupplierList(response?.data);
      } else {
        setSupplierList([]);
      }
    } catch (error) {
      console.error("Error fetching suppliers:", error);
      setSupplierList([]);
    } finally {
    }
  };
  useEffect(() => {
    fetchSupplierList();
    fetchItemsDropdown();
    fetchItemsDropdown2();
  }, []);

  // Check if we are editing on mount
  useEffect(() => {
    if (id || location.state?.billData) {
      setIsEditMode(true);
      if (location.state?.billData) {
        const data = location.state.billData;
        setBillId(data.id);
        setBillNumber(data.bill_number);
        setSupplier(data.supplier_id);
        setBillDate(data.date);
        setDueDate(data.due_date);
        setItems(data.description || []);
      }
    }
  }, [id, location.state]);

  const calculateItemTotal = () => {
    return (
      (parseFloat(currentQuantity) || 0) * (parseFloat(currentUnitPrice) || 0)
    );
  };

  // const addItem = () => {
  //   if (currentItem && currentQuantity && currentUnitPrice) {
  //     const newItem = {
  //       item: currentItem,
  //       quantity: parseFloat(currentQuantity),
  //       unit_price: parseFloat(currentUnitPrice), // Matching API naming
  //       item_total: calculateItemTotal()
  //     };
  //     setItems([...items, newItem]);
  //     setCurrentItem('');
  //     setCurrentQuantity('');
  //     setCurrentUnitPrice('');
  //     setShowItemValidation(false);
  //   } else {
  //     setShowItemValidation(true);
  //   }
  // };

  const addItem = () => {
    if (currentItem && currentQuantity && currentUnitPrice) {
      const newItem = {
        item: currentItem,
        quantity: parseFloat(currentQuantity),
        unit_price: parseFloat(currentUnitPrice),
        item_total: calculateItemTotal(),

        // ✅ ONLY for stock items
        ...(selectedStockObject && {
          checkstock: true,
          ...selectedStockObject,
        }),
      };

      setItems([...items, newItem]);

      // reset
      setCurrentItem("");
      setCurrentQuantity("");
      setCurrentUnitPrice("");
      setSelectedStock("");
      setSelectedStockObject(null);

      setShowItemValidation(false);
    } else {
      setShowItemValidation(true);
    }
  };
  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const validateDates = () => {
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const bill = billDate ? new Date(billDate) : null;
    const due = dueDate ? new Date(dueDate) : null;

    let dateErrors = {};

    // Rule 1: Due date should not be before today
    if (due && due < todayDate) {
      dateErrors.dueDate = "Due date cannot be before today";
    }

    // Rule 2: Due date should not be before bill date
    if (bill && due && due < bill) {
      dateErrors.dueDate = "Due date cannot be before bill date";
    }

    setErrors((prev) => ({
      ...prev,
      ...dateErrors,
    }));

    return Object.keys(dateErrors).length === 0;
  };

  const validateForm = () => {
    let newErrors = {};

    if (!billNumber?.trim()) {
      newErrors.billNumber = "Bill number is required";
    }

    if (!supplier) {
      newErrors.supplier = "Supplier is required";
    }

    if (!billDate) {
      newErrors.billDate = "Bill date is required";
    }

    if (!dueDate) {
      newErrors.dueDate = "Due date is required";
    }

    if (!items || items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      const hasEmptyItem = items.some(
        (item) => !item.item?.trim() || !item.quantity || !item.unit_price,
      );

      if (hasEmptyItem) {
        newErrors.items = "Please fill all item fields";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ true if no errors
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const isValid = validateForm();
    const isDateValid = validateDates();

    if (!isValid || !isDateValid) {
      toast.error("Please fill the required fields");
      return;
    }

    setIsLoading(true);

    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",
      bill_number: billNumber,
      supplier_id: Number(supplier),
      date: billDate,
      due_date: dueDate,
      note: description,
      // description: items.map(item => ({
      //   item: item.item,
      //   quantity: Number(item.quantity),
      //   unit_price: Number(item.unit_price),
      //   item_total: Number(item.item_total),
      //   ...(isEditMode && item.id && { id: item.id }) // Include item ID if updating
      // }))

      description: items.map((item) => ({
        item: item.item,
        quantity: Number(item.quantity),
        unit_price: Number(item.unit_price),
        item_total: Number(item.item_total),

        // ✅ include stock fields ONLY if it's a stock item
        ...(item.checkstock && {
          checkstock: true,
          store_name: item.store_name,
          product_name: item.product_name,
          stock_count: item.stock_count,
          product_id: item.product_id,
          store_id: item.store_id,
        }),

        // ✅ keep edit mode support
        ...(isEditMode && item.id && { id: item.id }),
      })),
    };

    // Add main ID for updates
    if (isEditMode) {
      requestBody.id = billId || Number(id);
    }

    const apiEndpoint = isEditMode
      ? ApiConfig.billUpdate
      : ApiConfig.billCreate;

    try {
      const response = await simplePostCall(
        apiEndpoint,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        // setShowSuccessToast(true);
        toast.success(response?.message || "Bill created successfully");
        setTimeout(() => navigate("/accountant/bill"), 2000);
      } else {
        toast.error(response?.error_message || "Something went wrong");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Network error occurred.");
    } finally {
      setIsLoading(false);
    }
  };
  // 1. Trigger the fetch when in Edit Mode
  // useEffect(() => {
  //   if (id) {
  //     setIsEditMode(true);
  //     loadBillDetails();
  //   }
  // }, [id]);
  useEffect(() => {
    if (id && dropdownsLoaded) {
      setIsEditMode(true);
      loadBillDetails();
    }
  }, [id, dropdownsLoaded]);

  // 2. The Fetch Function
  // Helper to convert DD/MM/YYYY to YYYY-MM-DD for the date input
  const formatDateForInput = (dateStr) => {
    if (!dateStr || !dateStr.includes("/")) return dateStr;
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  };

  const loadBillDetails = async () => {
    setIsLoading(true);
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      id: Number(id), // or whatever key your API expects for the bill ID
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billview,
        JSON.stringify(requestBody),
      );

      if (response?.result && response.data?.length > 0) {
        // 1. Get Header info from the first element
        const header = response.data[0];

        const parseAmount = (val) => {
          if (!val || val === "null") return 0;
          return Number(String(val).replace(/[^0-9.]/g, "")) || 0;
        };

        setBillNumber(header.bill_number || "");
        setSupplier(header.supplier_id || header.bill_supplier || "");
        setBillDate(formatDateForInput(header.bill_date));
        setDueDate(formatDateForInput(header.bill_due_date));

        if (response?.itemList?.length > 0) {
          setBillItemsList(response.itemList);
        }

        const mappedItems = response.data.map((row) => {
          const stockMatch = stockList.find(
            (s) => s.product_name === row.bill_item_name,
          );

          return {
            id: row.bill_item_id || row.id,
            item: row.bill_item_name,
            quantity: Number(row.bill_item_quantity),
            unit_price: parseAmount(row.bill_item_price),
            item_total: parseAmount(row.total_amount),

            ...(stockMatch && {
              checkstock: true,
              store_id: stockMatch.store_id,
              product_id: stockMatch.product_id,
              stock_count: stockMatch.stock_count,
            }),
          };
        });

        setItems(mappedItems);
      }
    } catch (error) {
      console.error("Error loading bill:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteBillItem = async (item, index) => {
    const body = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: item.id,
      quantity: Number(item.quantity),

      // ✅ ONLY if stock item
      ...(item.checkstock && {
        negativecheck: "true",
        store_id: item.store_id,
        product_id: item.product_id,
        stock_count: item.stock_count,
      }),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.billDeleteItem,
        JSON.stringify(body),
      );

      if (res?.result) {
        toast.success("Item deleted successfully");
        setItems((prev) => prev.filter((_, i) => i !== index));
      } else {
        toast.error(res?.message || "Failed to delete item");
      }
    } catch {
      toast.error("Network error while deleting item");
    }
  };

  const [itemsDropdown, setItemsDropdown] = useState([]);
  const fetchItemsDropdown = async () => {
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      id: 99999999999999, // or whatever key your API expects for the bill ID
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billview,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        setItemsDropdown(response?.itemList || []);
      }
    } catch (error) {
      console.error("Error loading bill:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (billDate && dueDate && new Date(dueDate) < new Date(billDate)) {
      setDueDate("");
    }
  }, [billDate]);

  const today = new Date().toISOString().split("T")[0];
  return (
    <div className="create-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="special-header panel-white-all">
        <h4 className="page-title">{isEditMode ? "Update Bill" : "Create Bill"}</h4>
      </div>

      <div className="yc-list-body">

        <div className="form-row-card">
          <div className="row-grid-two">
            <Form.Group>
              <Form.Label>
                Bill Number <span className="required-star">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={billNumber}
                onChange={(e) => {
                  setBillNumber(e.target.value);
                  setErrors((prev) => ({ ...prev, billNumber: null })); // live red border remove
                }}
                isInvalid={!!errors.billNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.billNumber}
              </Form.Control.Feedback>
            </Form.Group>
            {console.log("supplierList--", supplierList)}
            <Form.Group>
              <Form.Label>
                Supplier <span className="required-star">*</span>
              </Form.Label>
              <Form.Select
                value={supplier}
                onChange={(e) => {
                  setSupplier(e.target.value);
                  setErrors((prev) => ({ ...prev, supplier: null }));
                }}
                isInvalid={!!errors.supplier}
              >
                <option value="">Select</option>
                {supplierList?.length > 0 &&
                  supplierList?.map((item) => (
                    <option key={item.supplier_id} value={item.supplier_id}>
                      {item.supplier_name}{" "}
                    </option>
                  ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.supplier}
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          <div className="row-grid-two mt-3">
            <Form.Group>
              <Form.Label>Bill Date</Form.Label>
              <Form.Control
                type="date"
                value={billDate}
                onChange={(e) => {
                  setBillDate(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    billDate: null,
                    dueDate: null,
                  }));
                  if (dueDate && new Date(e.target.value) > new Date(dueDate))
                    setDueDate("");
                }}
                isInvalid={!!errors.billDate}
              />
              <Form.Control.Feedback type="invalid">
                {errors.billDate}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                value={dueDate}
                min={billDate || today} // 🔥 KEY FIX
                 onChange={(e) => {
                  setDueDate(e.target.value);
                  setErrors((prev) => ({ ...prev, dueDate: null }));
                }}
                isInvalid={!!errors.dueDate}
              />
              <Form.Control.Feedback type="invalid">
                {errors.dueDate}
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          {/* EXPENSE TYPE */}
          <div className="row-grid-two mt-3">
            {/* <Form.Group>
  <Form.Label>Expense Type</Form.Label>
  <Form.Select
    value={selectedExpense}
    onChange={(e) => {
      setSelectedExpense(e.target.value);
      setCurrentItem(e.target.value);
    }}
  >
    <option value="">Select</option>
    {expenseList.map((e) => (
      <option key={e.expense_type_id} value={e.expense_type_name}>
        {e.expense_type_name}
      </option>
    ))}
  </Form.Select>
</Form.Group> */}

            <Form.Group>
              <Form.Label>Expense Type</Form.Label>
              <Select
                options={expenseOptions}
                value={
                  expenseOptions.find((o) => o.value === selectedExpense) ||
                  null
                }
                onChange={(option) => {
                  setSelectedExpense(option?.value || "");
                  setSelectedBillItem("");
                  setSelectedStock("");
                  setCurrentItem(option?.value || "");
                  setErrors((prev) => ({ ...prev, items: null }));
                }}
                isClearable
                placeholder="Select expense type"
              />
            </Form.Group>

            {/* BILL ITEMS */}
            {/* <Form.Group>
  <Form.Label>Bill Item</Form.Label>
  <Form.Select
    value={selectedBillItem}
    onChange={(e) => {
      setSelectedBillItem(e.target.value);
      setCurrentItem(e.target.value);
    }}
  >
    <option value="">Select</option>
    {billItemsList.map((b) => (
      <option key={b.bill_item_id} value={b.bill_item_name}>
        {b.bill_item_name}
      </option>
    ))}
  </Form.Select>
</Form.Group> */}

            <Form.Group>
              <Form.Label>Bill Item</Form.Label>
              <Select
                options={billItemOptions}
                value={
                  billItemOptions.find((o) => o.value === selectedBillItem) ||
                  null
                }
                onChange={(option) => {
                  setSelectedBillItem(option?.value || "");
                  setSelectedExpense("");
                  setSelectedStock("");
                  setCurrentItem(option?.value || "");
                   setErrors((prev) => ({ ...prev, items: null }));
                }}
                isClearable
                placeholder="Select bill item"
              />
            </Form.Group>

            {/* STOCK ITEMS */}
            {/* <Form.Group>
  <Form.Label>Stock Item</Form.Label>
  <Form.Select
    value={selectedStock}
     onChange={(e) => {
    const stockObj = stockList.find(
      (s) => s.product_name === e.target.value
    );

    setSelectedStock(e.target.value);
    setSelectedStockObject(stockObj || null); // ✅ store full object
    setSelectedExpense("");
    setSelectedBillItem("");
    setCurrentItem(e.target.value); // fills Item text field
  }}
  >
    <option value="">Select</option>
    {stockList.map((s, index) => (
      <option key={index} value={s.product_name}>
        {s.product_name} ({s.stock_count})
      </option>
    ))}
  </Form.Select>
</Form.Group> */}

            <Form.Group>
              <Form.Label>Stock Item</Form.Label>
              <Select
                options={stockOptions}
                value={
                  stockOptions.find((o) => o.value === selectedStock) || null
                }
                onChange={(option) => {
                  setSelectedStock(option?.value || "");
                  setSelectedExpense("");
                  setSelectedBillItem("");
                  setCurrentItem(option?.value || "");

                  // ✅ FULL STOCK OBJECT STORED
                  setSelectedStockObject(option?.original || null);
                   setErrors((prev) => ({ ...prev, items: null }));
                }}
                isClearable
                placeholder="Select stock item"
              />
            </Form.Group>
          </div>
          {/* Item Input Section */}
          <div className="row-grid-four mt-4">
            {/* <Form.Group>
              <Form.Label>Item</Form.Label>
              <Form.Select value={currentItem} onChange={(e) => setCurrentItem(e.target.value)}>
                <option value="">Select</option>
                {itemsDropdown?.map((item)=>(
                   <option key={item.bill_item_id}  value={item.bill_item_name}>{item.bill_item_name}</option>
                ))}
              
              </Form.Select>
            </Form.Group> */}

            <Form.Group>
              <Form.Label>Item</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter item or select from dropdowns"
                value={currentItem}
                onChange={(e) => {
                  setCurrentItem(e.target.value);
                  setErrors((prev) => ({ ...prev, items: null }));
                }}
                isInvalid={!!errors.items}
              />
              {errors.items && (
                <Form.Control.Feedback type="invalid">
                  {errors.items}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                value={currentQuantity}
                onChange={(e) =>{
                 setCurrentQuantity(e.target.value);
                 setErrors((prev) => ({ ...prev, items: null }));
                 }}
                isInvalid={!!errors.items}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Unit Price</Form.Label>
              <Form.Control
                type="number"
                value={currentUnitPrice}
                onChange={(e) => setCurrentUnitPrice(e.target.value)}
                isInvalid={!!errors.items}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Total</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="text"
                  value={`${customer_currency} ${calculateItemTotal().toFixed(2)}`}
                  readOnly
                />
                <Button className="btn btn-primary" onClick={addItem}>
                  +
                </Button>
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
              />
            </Form.Group>
          </div>

          {/* Items Table Summary */}
          {items.length > 0 && (
            <Table striped bordered className="mt-4">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.item}</td>
                    <td>{item.quantity}</td>
                    <td>{customer_currency} {item.unit_price}</td>
                    <td>{customer_currency} {item.item_total}</td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                          if (isEditMode && item.id) {
                            deleteBillItem(item, index);
                          } else {
                            removeItem(index);
                          }
                        }}
                      >
                        x
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <div className="d-flex justify-content-end mt-4">
            <Button
              onClick={handleSubmit}
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner size="sm" />
              ) : isEditMode ? (
                "Update Bill"
              ) : (
                "Create Bill"
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
